import React, { useEffect, useState, useContext } from "react";
// import { Link } from "react-router-dom";
import { useHttpClient } from "../hooks/http-hook";
import { RegisterContext } from "../context/register-context";
// import { ProgressContext } from "../context/progress-context";

import "./SurveyResultPage.css";

// import Button from "../UI/Button";

import AnswerList from "../answers/AnswerList";
import LoadingSpinner from "../UI/LoadingSpinner";

const SurveyResultPage = () => {
  const [loadedAnswers, setLoadedAnswers] = useState();
  const { sendRequest } = useHttpClient();

  const register = useContext(RegisterContext);
  // const progress = useContext(ProgressContext);
  const userId = register.userId;

  // const userId = useParams().userId;

  useEffect(() => {
    const fetchAnswers = async () => {
      try {
        // console.log("dsso", userId);

        const responseData = await sendRequest(
          // `http://localhost:5000/api/surveys/user/${userId}`
          `${process.env.REACT_APP_BACKEND_URL}/users/surveys/${userId}`
        );
        console.log(responseData)
        setLoadedAnswers(responseData.answersPopulated);
        
      } catch (err) {
        console.log(err);
      }
    };
    fetchAnswers();
  }, [sendRequest, userId]);

  if(!loadedAnswers) return null
  // console.log(loadedAnswers);  

  return (
    <>
      <h2 className="thank-text">Vielen Dank für Ihre Teilnahme! Hier ist die Übersicht Ihres Ergebnisse</h2>
      {/* {!loadedAnswers && <p className="thank-text">Loading...</p>} */}
      {loadedAnswers ? <AnswerList items={loadedAnswers} /> : <LoadingSpinner />}
      {/* <Link to="/">
        <Button type="button" value="zurück zur Umfrage" onClick={progress.resetProgress} />
      </Link> */}
    </>
  );
};

export default SurveyResultPage;
